import app from 'flarum/forum/app';

import Component from 'flarum/common/Component';
import Checkbox from 'flarum/common/components/Checkbox';
import Stream from 'flarum/common/utils/Stream';

export default class NecrobumpingCheck extends Component {
  oninit(vnode) {
    super.oninit(vnode);
  }

  view() {
    const customDescription = app.data['fof-prevent-necrobumping.message.description'];

    return (
      <div>
        <div className="Alert">
          <div className="Alert-body">
            <div className="hide">
              <p>{customDescription || app.translator.trans('fof-prevent-necrobumping.forum.composer.warning.description')}</p>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
